import debounce from "lodash/debounce";

import { logProductAnalyticsEvent } from "@/features/analytics";

export type VideoLibraryAnalyticsProps =
  | { kind: "recording"; recordingId: string }
  | { kind: "embed"; id: string };

const FIELD_UPDATE_DEBOUNCE_MS = 2000;

function videoLibraryProperties(
  props: VideoLibraryAnalyticsProps,
  extra?: Record<string, unknown>
) {
  if (props.kind === "recording") {
    return {
      source_type: "recording" as const,
      recording_id: props.recordingId,
      ...extra,
    };
  }
  return {
    source_type: "embed" as const,
    recording_id: props.id,
    ...extra,
  };
}

export const trackLibraryVideoTitleUpdate = debounce(
  (props: VideoLibraryAnalyticsProps) => {
    logProductAnalyticsEvent({
      name: "ch_library_video_title_update",
      properties: videoLibraryProperties(props),
    });
  },
  FIELD_UPDATE_DEBOUNCE_MS
);

export const trackLibraryVideoDescriptionUpdate = debounce(
  (props: VideoLibraryAnalyticsProps) => {
    logProductAnalyticsEvent({
      name: "ch_library_video_description_update",
      properties: videoLibraryProperties(props),
    });
  },
  FIELD_UPDATE_DEBOUNCE_MS
);

export const trackLibraryVideoThumbnailChange = (
  props: VideoLibraryAnalyticsProps
) => {
  logProductAnalyticsEvent({
    name: "ch_library_video_thumbnail_change",
    properties: videoLibraryProperties(props, { action: "upload" }),
  });
};

export const trackLibraryVideoFormResetClick = (
  props: VideoLibraryAnalyticsProps
) => {
  logProductAnalyticsEvent({
    name: "ch_library_video_form_reset_click",
    properties: videoLibraryProperties(props),
  });
};

export const trackLibraryVideoCopyClick = (
  props: VideoLibraryAnalyticsProps
) => {
  logProductAnalyticsEvent({
    name: "ch_library_video_copy_click",
    properties: videoLibraryProperties(props),
  });
};

export const trackLibraryVideoShareClick = (
  props: VideoLibraryAnalyticsProps
) => {
  logProductAnalyticsEvent({
    name: "ch_library_video_share_click",
    properties: videoLibraryProperties(props),
  });
};

export const trackContentPageOpenSharedUrl = (
  props: VideoLibraryAnalyticsProps,
  queryParam: "videoId"
) => {
  logProductAnalyticsEvent({
    name: "ch_content_page_open_shared_url",
    properties: videoLibraryProperties(props, { queryParam }),
  });
};

export const trackLibraryVideoSourceUpdate = (
  props: VideoLibraryAnalyticsProps
) => {
  logProductAnalyticsEvent({
    name: "ch_library_video_source_update",
    properties: videoLibraryProperties(props),
  });
};
